/**
 * Move `list[from]` to `to` and return the new list plus the full contiguous
 * `orderIndex` permutation to persist. Sending every row (not just the ones
 * that "changed") is what makes reorder safe when server indexes have gaps
 * or duplicates — the old "reuse existing values" approach silently no-op'd.
 *
 * `base` offsets the indexes for paginated lists (`(page - 1) * limit`).
 */
export function reorderPermutation<T extends { pid: string }>(
  list: readonly T[],
  from: number,
  to: number,
  base = 0,
): { next: T[]; items: { pid: string; orderIndex: number }[] } {
  const next = [...list];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return { next, items: next.map((x, i) => ({ pid: x.pid, orderIndex: base + i })) };
}
